module.exports = __webpack_public_path__ + "static/media/profilepicture.bf27a833.svg";